// extracted by mini-css-extract-plugin
module.exports = {"noFooter":"useModalChangePassword_noFooter__tgSMs","buttons":"useModalChangePassword_buttons__3lElO","base":"useModalChangePassword_base__CAQT4"};